const BlockActionVariableDefault = {
    name : "Set a variable",
    action_type : { name : "set_var"},
    type : { name : 'action'},
    data : {
        variables : [
            { value : "", is_operation : false, index : '0', variable : null}
        ]
    }
}

const BlockActionVariableServerDefault = {
    name : "Set a variable",
    action_type : "set_var"
}

export { BlockActionVariableDefault, BlockActionVariableServerDefault }